<div class="settings-card">
    <div class="settings-card__header">
        <img src="/assets/images/copii.svg" alt="" />
        <div class="settings-card__header-headline">
            <h2>Copii</h2>
            <h4>Evidență copii - Platforma Online - Direcția Generală de Asistență Socială și Protecția Copilului Sector
                4</h4>
        </div>
    </div>
</div>

<div class="requests-page">
    <div class="content-box">
        <div class="row">
            <div class="col-sm-12">
                <div class="section">
                    <div class="section-top">
                        <h3 class="section-title">Copii</h3>
                        <div class="section-top-actions">
                            <button type="button" class="btn btn-sm btn-info pull-right ms-1"
                                (click)="rerenderDT(false)">
                                <i class="fa-solid fa-arrows-rotate"></i>
                            </button>
                            <button *ngIf="permissionsService.hasPermission('dgaspc-module.copii.add')" type="button"
                                class="btn btn-sm btn-primary pull-right ms-1" (click)="openAddDialog()">
                                <i class="fa-solid fa-plus"></i>
                                Adaugă
                            </button>
                        </div>
                    </div>

                    <div class="card-container request-filter p-2" *ngIf="showCard">
                        <!-- <form [formGroup]="searchParamsForm" (ngSubmit)="applyFilters()">
                            <br />
                            <div class="row">

                                <div class="col-md-6">
                                    <mat-form-field class="w-100">
                                        <mat-label>Scop document</mat-label>
                                        <mat-select formControlName="scopcf">
                                            <mat-option *ngFor="let scop of scopParameters" [value]="scop.value">
                                                {{ scop.key }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                          
                                <div class="col-md-6">
                                    <mat-form-field class="w-100">
                                        <mat-label>Fără listă patrimoniu</mat-label>
                                        <mat-select formControlName="fara_lista_patrimoniu">
                                            <mat-option *ngFor="let param of parameters" [value]="param.value">
                                                {{ param.key }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="row">

                                <div class="col-md-6">
                                    <mat-form-field class="w-100">
                                        <mat-label>Confirmat</mat-label>
                                        <mat-select formControlName="confirmed">
                                            <mat-option *ngFor="let param of parameters" [value]="param.value">
                                                {{ param.key }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>

                                <div class="col-md-6">
                                    <mat-form-field class="w-100">
                                        <mat-label>Nr. Solicitare</mat-label>
                                        <input matInput formControlName="numar_solicitare" />
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <mat-form-field class="w-100">
                                        <mat-label>CNP/CUI</mat-label>
                                        <input matInput formControlName="cnp_cui" />
                                    </mat-form-field>
                                </div>

                                <div class="col-md-6">
                                    <mat-form-field class="w-100">
                                        <mat-label>ROL Fiscal ID</mat-label>
                                        <input matInput formControlName="rol_id" />
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-12">
                                    <mat-form-field class="w-100">
                                        <mat-label>Nume Cetățean/Denumire</mat-label>
                                        <input matInput formControlName="full_name" />
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col d-flex justify-content-start">
                                    <button (click)="toggleCard()" type="button" class="btn btn-sm btn-warning closeBtn">
                                        Închide
                                    </button>
                                </div>
                                <div class="col buttons-submit">
                                    <button (click)="resetForm()" type="button" class="btn btn-sm btn-secondary">
                                        Resetează
                                    </button>
                                    <button type="submit" class="btn btn-sm btn-primary ms-2">
                                        Aplică
                                    </button>
                                </div>
                            </div>
                        </form> -->
                    </div>

                    <!-- <div class="row d-flex p-2">
                        <div class="col d-flex justify-content-start">
                            <button class="action-button" (click)="toggleCard()" [class.active]="showCard">
                                <img src="assets/images/filter-icon.png" alt="Filtrare" />
                                <span>Filtre</span>
                            </button>
                        </div>
                    </div> -->

                    <div class="table-container">
                        <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="row-border hover w-100">
                        </table>
                    </div>
                    <div class="section-spinner position-absolute" *ngIf="isLoading">
                        <div class="spinner position-absolute top-50 start-50 translate-middle">
                            <mat-spinner></mat-spinner>
                            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>